import React, { useState } from 'react';
import { PageTypeRolesProps } from '../PageTypeRolesBlock';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';
import { BlockBar, BlockBarAnchor, useBlockBarCreateHref } from '../../../_lib/components/BlockBar';
import { Icons } from '../../../components/atoms/SVG';
import { PageTypeRolesBlockDefaultView } from '../views/PageTypeRolesBlockDefaultView';
import { PageTypeRolesBlockEditView } from '../views/PageTypeRolesBlockEditView';

export function PageTypeRolesInteractions({ views }: PageTypeRolesProps) {
  const { t } = useSonTranslation('PageTypeRoles');
  const { refresh } = useRefreshBlock();
  const id = useHtmlValidId();

  const [activeView, setActiveView] = useState<'default' | 'edit'>('default');
  const currentActiveViewHref = useBlockBarCreateHref(
    activeView,
    { default: views.edit?.href, edit: views.default?.href },
    id,
  );

  return (
    <>
      <BlockBar heading={t('editRoles')} hierarchy={3} modifier="border-bottom">
        <BlockBarAnchor
          href={currentActiveViewHref}
          text={t('editRoles')}
          svgSpriteId={activeView === 'default' ? Icons.EDIT_PENCIL : Icons.DECLINE_CROSS}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();

            if (activeView === 'default') {
              setActiveView('edit');
            } else {
              setActiveView('default');
              refresh();
            }
          }}
          aria-controls={id}
          aria-expanded={activeView === 'edit'}
        />
      </BlockBar>
      <div id={id}>
        {activeView === 'default'
          ? (
              <PageTypeRolesBlockDefaultView {...views.default} additionalProps={{ headingHierarchy: 4 }} />
            )
          : null}
        {activeView === 'edit' ? <PageTypeRolesBlockEditView {...(views.edit as PageTypeRolesBlockEditView)} /> : null}
      </div>
    </>
  );
}
